(function () {
  'use strict';

  var popup = document.querySelector(
    '[data-lux-cart-rescue]'
  );

  if (!popup) {
    return;
  }

  if (
    popup.getAttribute(
      'data-lux-initialized'
    ) === 'true'
  ) {
    return;
  }

  popup.setAttribute(
    'data-lux-initialized',
    'true'
  );


  /* ========================================
     CONFIGURACIÓN
  ======================================== */

  var discountCode =
    popup.getAttribute(
      'data-discount-code'
    ) || 'VUELVE10';


  var discountUrl =
    popup.getAttribute(
      'data-discount-url'
    ) ||
    '/discount/' +
      encodeURIComponent(discountCode) +
      '?redirect=/cart';


  /*
    Si se elimina el último producto,
    permitimos igualmente mostrar el popup.
  */
  var showAfterEmptyingCart =
    true;


  /*
    Máximo una aparición por sesión.
  */
  var sessionKey =
    'lux-cart-rescue-shown-v1';


  var feedbackKey =
    'lux-cart-rescue-feedback-v1';


  /* ========================================
     RUTAS SHOPIFY
  ======================================== */

  var shopifyRoot =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  var cartJsonUrl =
    shopifyRoot + 'cart.js';


  var cartAddUrl =
    shopifyRoot + 'cart/add.js';


  /* ========================================
     ELEMENTOS
  ======================================== */

  var closeButtons =
    Array.prototype.slice.call(
      popup.querySelectorAll(
        '[data-lux-rescue-close]'
      )
    );


  var copyButton =
    popup.querySelector(
      '[data-lux-rescue-copy]'
    );


  var cta =
    popup.querySelector(
      '[data-lux-rescue-cta]'
    );


  var feedback =
    popup.querySelector(
      '[data-lux-rescue-feedback]'
    );


  var toast =
    document.querySelector(
      '[data-lux-rescue-toast]'
    );


  var popupImage =
    popup.querySelector(
      '[data-lux-rescue-image]'
    );


  /* ========================================
     ESTADO
  ======================================== */

  var originalFetch =
    window.fetch.bind(window);


  var cartState = {
    item_count: 0,
    items: []
  };


  var cartReady =
    false;


  var popupOpen =
    false;


  var syncTimer =
    null;


  var previousBodyOverflow =
    '';


  var previousFocus =
    null;


  /*
    Aquí guardamos temporalmente lo que
    el cliente acaba de eliminar.

    NO se vuelve a añadir hasta que pulse
    "Volver al carrito".
  */
  var pendingRemovedItems = [];


  /* ========================================
     SESSION STORAGE
  ======================================== */

  function sessionGet(key) {
    try {
      return window.sessionStorage
        .getItem(key);
    } catch (error) {
      return null;
    }
  }


  function sessionSet(
    key,
    value
  ) {
    try {
      window.sessionStorage
        .setItem(
          key,
          value
        );
    } catch (error) {}
  }


  function sessionRemove(key) {
    try {
      window.sessionStorage
        .removeItem(key);
    } catch (error) {}
  }


  /* ========================================
     OBTENER CARRITO
  ======================================== */

  function fetchCart() {
    return originalFetch(
      cartJsonUrl,
      {
        method:
          'GET',

        credentials:
          'same-origin',

        headers: {
          Accept:
            'application/json'
        },

        cache:
          'no-store'
      }
    )
      .then(
        function (response) {

          if (!response.ok) {
            throw new Error(
              'No se pudo cargar el carrito'
            );
          }

          return response.json();

        }
      );
  }


  function normalizeCart(cart) {
    if (!cart) {
      return {
        item_count: 0,
        items: []
      };
    }

    return {
      item_count:
        Number(
          cart.item_count
        ) || 0,

      items:
        Array.isArray(
          cart.items
        )
          ? cart.items
          : []
    };
  }


  /* ========================================
     IDENTIFICAR LÍNEAS
  ======================================== */

  function getItemKey(item) {
    if (!item) {
      return '';
    }

    if (item.key) {
      return String(
        item.key
      );
    }

    if (item.variant_id) {
      return String(
        item.variant_id
      );
    }

    if (item.id) {
      return String(
        item.id
      );
    }

    return '';
  }


  /*
    Convierte un item del carrito en el
    formato que Shopify necesita para
    volver a añadirlo.
  */
  function createRestoreItem(
    item,
    quantity
  ) {
    if (!item) {
      return null;
    }


    var variantId =
      item.variant_id ||
      item.id;


    if (!variantId) {
      return null;
    }


    var restoreItem = {
      id:
        variantId,

      quantity:
        Math.max(
          1,
          Number(quantity) || 1
        )
    };


    /*
      Conservamos propiedades de línea.

      Importante para packs, personalizaciones,
      configuraciones y otros productos que
      utilicen line item properties.
    */
    if (
      item.properties &&
      typeof item.properties ===
        'object' &&
      Object.keys(
        item.properties
      ).length
    ) {

      restoreItem.properties =
        Object.assign(
          {},
          item.properties
        );

    }


    /*
      Conservamos selling plan
      si el producto lo tuviera.
    */
    if (
      item.selling_plan_allocation &&
      item.selling_plan_allocation
        .selling_plan &&
      item.selling_plan_allocation
        .selling_plan.id
    ) {

      restoreItem.selling_plan =
        item.selling_plan_allocation
          .selling_plan.id;

    } else if (
      item.selling_plan
    ) {

      restoreItem.selling_plan =
        item.selling_plan;

    }


    return restoreItem;
  }


  /* ========================================
     DETECTAR QUÉ HA ELIMINADO
  ======================================== */

  function getRemovedItems(
    previousCart,
    nextCart
  ) {

    var previousItems =
      previousCart &&
      Array.isArray(
        previousCart.items
      )
        ? previousCart.items
        : [];


    var nextItems =
      nextCart &&
      Array.isArray(
        nextCart.items
      )
        ? nextCart.items
        : [];


    if (
      !previousItems.length
    ) {
      return [];
    }


    var nextMap = {};


    nextItems.forEach(
      function (item) {

        var key =
          getItemKey(item);


        if (!key) {
          return;
        }


        nextMap[key] =
          item;

      }
    );


    var removedItems = [];


    previousItems.forEach(
      function (previousItem) {

        var key =
          getItemKey(
            previousItem
          );


        if (!key) {
          return;
        }


        var previousQuantity =
          Number(
            previousItem.quantity
          ) || 0;


        var nextItem =
          nextMap[key];


        var nextQuantity =
          nextItem
            ? Number(
                nextItem.quantity
              ) || 0
            : 0;


        /*
          Ejemplos:

          1 -> 0 = restaura 1
          2 -> 1 = restaura 1
          3 -> 0 = restaura 3
        */
        var removedQuantity =
          previousQuantity -
          nextQuantity;


        if (
          removedQuantity <= 0
        ) {
          return;
        }


        var restoreItem =
          createRestoreItem(
            previousItem,
            removedQuantity
          );


        if (restoreItem) {

          removedItems.push(
            restoreItem
          );

        }

      }
    );


    return removedItems;
  }


  /* ========================================
     ACTUALIZAR ESTADO
  ======================================== */

  function updateCartState(cart) {

    cartState =
      normalizeCart(cart);


    cartReady =
      true;


    if (
      cartState.item_count > 0 &&
      popupImage
    ) {

      try {

        popupImage.loading =
          'eager';

      } catch (error) {}

    }

  }


  function initializeCart() {

    fetchCart()
      .then(
        function (cart) {

          updateCartState(
            cart
          );

        }
      )
      .catch(
        function () {

          cartReady =
            true;

        }
      );

  }


  /* ========================================
     POPUP
  ======================================== */

  function alreadyShown() {

    return (
      sessionGet(
        sessionKey
      ) === '1'
    );

  }


  function canOpen(
    allowPreviousCart
  ) {

    if (popupOpen) {
      return false;
    }


    if (alreadyShown()) {
      return false;
    }


    if (!cartReady) {
      return false;
    }


    if (
      cartState.item_count > 0
    ) {
      return true;
    }


    return (
      allowPreviousCart ===
      true
    );

  }


  function openPopup(
    reason,
    allowPreviousCart
  ) {

    if (
      !canOpen(
        allowPreviousCart
      )
    ) {
      return false;
    }


    /*
      Si el popup no viene de haber
      eliminado producto, no debe existir
      ningún producto pendiente de restaurar.
    */
    if (
      reason !==
      'product-removed'
    ) {

      pendingRemovedItems =
        [];

    }


    popupOpen =
      true;


    sessionSet(
      sessionKey,
      '1'
    );


    popup.setAttribute(
      'data-trigger',
      reason || 'unknown'
    );


    previousFocus =
      document.activeElement;


    previousBodyOverflow =
      document.body.style
        .overflow;


    document.body.style
      .overflow =
      'hidden';


    popup.hidden =
      false;


    window.requestAnimationFrame(
      function () {

        popup.classList.add(
          'is-visible'
        );


        var closeButton =
          popup.querySelector(
            '.lux-cart-rescue__close'
          );


        if (closeButton) {

          try {

            closeButton.focus({
              preventScroll:
                true
            });

          } catch (error) {

            closeButton.focus();

          }

        }

      }
    );


    return true;
  }


  function closePopup() {

    if (!popupOpen) {
      return;
    }


    popupOpen =
      false;


    popup.classList.remove(
      'is-visible'
    );


    document.body.style
      .overflow =
      previousBodyOverflow;


    window.setTimeout(
      function () {

        if (!popupOpen) {

          popup.hidden =
            true;

        }

      },
      260
    );


    if (
      previousFocus &&
      typeof previousFocus.focus ===
        'function'
    ) {

      try {

        previousFocus.focus({
          preventScroll:
            true
        });

      } catch (error) {}

    }

  }


  /* ========================================
     RESTAURAR PRODUCTOS ELIMINADOS
  ======================================== */

  function restoreRemovedItems() {

    if (
      !pendingRemovedItems.length
    ) {

      return Promise.resolve(
        false
      );

    }


    /*
      Hacemos una copia antes de enviar
      para evitar que otro proceso la modifique.
    */
    var itemsToRestore =
      pendingRemovedItems.map(
        function (item) {

          return Object.assign(
            {},
            item
          );

        }
      );


    return originalFetch(
      cartAddUrl,
      {
        method:
          'POST',

        credentials:
          'same-origin',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        body:
          JSON.stringify({
            items:
              itemsToRestore
          })
      }
    )
      .then(
        function (response) {

          if (!response.ok) {

            return response
              .text()
              .then(
                function (message) {

                  throw new Error(
                    message ||
                    'No se pudo restaurar el producto'
                  );

                }
              );

          }


          return response.json();

        }
      )
      .then(
        function () {

          /*
            Confirmamos que Shopify ya tiene
            los productos restaurados antes
            de cambiar de página.
          */
          return fetchCart();

        }
      )
      .then(
        function (cart) {

          updateCartState(
            cart
          );


          /*
            Ya se restauraron correctamente.
          */
          pendingRemovedItems =
            [];


          return true;

        }
      );

  }


  /* ========================================
     COPIAR DESCUENTO
  ======================================== */

  function fallbackCopy(text) {

    return new Promise(
      function (resolve) {

        var textarea =
          document.createElement(
            'textarea'
          );


        textarea.value =
          text;


        textarea.setAttribute(
          'readonly',
          ''
        );


        textarea.style.position =
          'fixed';

        textarea.style.top =
          '-9999px';

        textarea.style.left =
          '-9999px';


        document.body.appendChild(
          textarea
        );


        textarea.select();


        var success =
          false;


        try {

          success =
            document.execCommand(
              'copy'
            );

        } catch (error) {

          success =
            false;

        }


        textarea.remove();


        resolve(
          success
        );

      }
    );

  }


  function copyDiscountCode() {

    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {

      return navigator.clipboard
        .writeText(
          discountCode
        )
        .then(
          function () {

            return true;

          }
        )
        .catch(
          function () {

            return fallbackCopy(
              discountCode
            );

          }
        );

    }


    return fallbackCopy(
      discountCode
    );

  }


  function showFeedback(
    copied
  ) {

    if (!feedback) {
      return;
    }


    feedback.textContent =
      copied
        ? 'Código ' +
          discountCode +
          ' copiado'
        : 'El código es ' +
          discountCode;


    feedback.classList.add(
      'is-visible'
    );

  }


  function showRestoreFeedback() {

    if (!feedback) {
      return;
    }


    feedback.textContent =
      'Producto restaurado. Aplicando descuento...';


    feedback.classList.add(
      'is-visible'
    );

  }


  function showRestoreError() {

    if (!feedback) {
      return;
    }


    feedback.textContent =
      'No hemos podido restaurar el producto. Inténtalo de nuevo.';


    feedback.classList.add(
      'is-visible'
    );

  }


  /* ========================================
     CTA BUSY
  ======================================== */

  function setCtaBusy(
    busy
  ) {

    if (!cta) {
      return;
    }


    if (busy) {

      cta.setAttribute(
        'aria-busy',
        'true'
      );


      cta.style.pointerEvents =
        'none';


      cta.style.opacity =
        '0.72';

    } else {

      cta.removeAttribute(
        'aria-busy'
      );


      cta.style.pointerEvents =
        '';


      cta.style.opacity =
        '';

    }

  }


  /* ========================================
     TOAST EN CARRITO
  ======================================== */

  function showToast() {

    if (!toast) {
      return;
    }


    toast.hidden =
      false;


    window.requestAnimationFrame(
      function () {

        toast.classList.add(
          'is-visible'
        );

      }
    );


    window.setTimeout(
      function () {

        toast.classList.remove(
          'is-visible'
        );


        window.setTimeout(
          function () {

            toast.hidden =
              true;

          },
          260
        );

      },
      3600
    );

  }


  function checkDiscountFeedback() {

    if (
      sessionGet(
        feedbackKey
      ) !== '1'
    ) {
      return;
    }


    sessionRemove(
      feedbackKey
    );


    if (
      window.location.pathname
        .indexOf('/cart') !==
      -1
    ) {

      window.setTimeout(
        showToast,
        250
      );

    }

  }


  /* ========================================
     CLICK EN VUELVE10
  ======================================== */

  if (copyButton) {

    copyButton.addEventListener(
      'click',
      function () {

        copyDiscountCode()
          .then(
            function (copied) {

              showFeedback(
                copied
              );

            }
          );

      }
    );

  }


  /* ========================================
     CTA "VOLVER AL CARRITO"
  ======================================== */

  if (cta) {

    cta.addEventListener(
      'click',
      function (event) {

        event.preventDefault();


        if (
          cta.getAttribute(
            'aria-busy'
          ) === 'true'
        ) {
          return;
        }


        setCtaBusy(
          true
        );


        /*
          Primero copiamos el código.
        */
        copyDiscountCode()
          .then(
            function (copied) {

              showFeedback(
                copied
              );


              var trigger =
                popup.getAttribute(
                  'data-trigger'
                );


              /*
                Si el popup apareció porque
                eliminó producto, PRIMERO
                deshacemos esa eliminación.
              */
              if (
                trigger ===
                  'product-removed' &&
                pendingRemovedItems.length
              ) {

                return restoreRemovedItems()
                  .then(
                    function () {

                      showRestoreFeedback();


                      sessionSet(
                        feedbackKey,
                        '1'
                      );


                      /*
                        Damos un mínimo margen
                        visual y después aplicamos
                        VUELVE10 y vamos al carrito.
                      */
                      window.setTimeout(
                        function () {

                          window.location
                            .assign(
                              discountUrl
                            );

                        },
                        350
                      );

                    }
                  )
                  .catch(
                    function (error) {

                      console.error(
                        '[Lux Cart Rescue]',
                        error
                      );


                      /*
                        IMPORTANTE:
                        si restaurar falla,
                        NO mandamos al cliente
                        a un carrito vacío.
                      */
                      showRestoreError();


                      setCtaBusy(
                        false
                      );

                    }
                  );

              }


              /*
                Para exit intent o cierre del
                carrito no hay nada que restaurar.
              */
              sessionSet(
                feedbackKey,
                '1'
              );


              window.setTimeout(
                function () {

                  window.location
                    .assign(
                      discountUrl
                    );

                },
                copied
                  ? 450
                  : 200
              );


              return null;

            }
          )
          .catch(
            function (error) {

              console.error(
                '[Lux Cart Rescue]',
                error
              );


              setCtaBusy(
                false
              );

            }
          );

      }
    );

  }


  /* ========================================
     CERRAR POPUP
  ======================================== */

  closeButtons.forEach(
    function (button) {

      button.addEventListener(
        'click',
        closePopup
      );

    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key ===
          'Escape' &&
        popupOpen
      ) {

        closePopup();

      }

    }
  );


  /* ========================================
     EXIT INTENT ESCRITORIO
  ======================================== */

  document.addEventListener(
    'mouseout',
    function (event) {

      if (
        window.innerWidth <
        990
      ) {
        return;
      }


      if (
        event.relatedTarget ||
        event.toElement
      ) {
        return;
      }


      if (
        event.clientY >
        8
      ) {
        return;
      }


      openPopup(
        'exit-intent',
        false
      );

    }
  );


  /* ========================================
     CIERRE CARRITO LATERAL
  ======================================== */

  var cartContainerSelector =
    [
      '#halo-cart-sidebar',
      '.halo-cart-sidebar',
      '.previewCart',
      '.cart-sidebar',
      '.cart-drawer',
      '#CartDrawer',
      '[data-cart-drawer]',
      '[data-cart-sidebar]',
      '[id*="CartDrawer"]'
    ].join(',');


  var cartCloseSelector =
    [
      '.halo-sidebar-close',
      '[data-cart-close]',
      '[data-close-cart]',
      '[data-cart-drawer-close]',
      '.cart-drawer__close',
      '.drawer__close',
      '.previewCart-close',
      '.cartDrawer-close'
    ].join(',');


  document.addEventListener(
    'click',
    function (event) {

      var closeTrigger =
        event.target.closest(
          cartCloseSelector
        );


      if (!closeTrigger) {
        return;
      }


      var cartContainer =
        closeTrigger.closest(
          cartContainerSelector
        );


      if (!cartContainer) {
        return;
      }


      window.setTimeout(
        function () {

          fetchCart()
            .then(
              function (cart) {

                updateCartState(
                  cart
                );


                openPopup(
                  'cart-close',
                  false
                );

              }
            )
            .catch(
              function () {}
            );

        },
        100
      );

    },
    true
  );


  /* ========================================
     DETECTAR MUTACIONES DE CARRITO
  ======================================== */

  function isCartMutationUrl(
    url
  ) {

    if (!url) {
      return false;
    }


    var cleanUrl =
      String(url);


    return (
      /\/cart\/add(?:\.js)?(?:\?|$)/.test(
        cleanUrl
      ) ||
      /\/cart\/change(?:\.js)?(?:\?|$)/.test(
        cleanUrl
      ) ||
      /\/cart\/update(?:\.js)?(?:\?|$)/.test(
        cleanUrl
      ) ||
      /\/cart\/clear(?:\.js)?(?:\?|$)/.test(
        cleanUrl
      )
    );

  }


  function scheduleCartSync() {

    if (syncTimer) {

      window.clearTimeout(
        syncTimer
      );

    }


    syncTimer =
      window.setTimeout(
        function () {

          /*
            Guardamos una foto del carrito
            ANTES de consultar el estado nuevo.
          */
          var previousCart = {
            item_count:
              cartState.item_count,

            items:
              cartState.items.slice()
          };


          fetchCart()
            .then(
              function (nextCartRaw) {

                var nextCart =
                  normalizeCart(
                    nextCartRaw
                  );


                /*
                  Calculamos exactamente qué
                  cantidad ha eliminado.
                */
                var removedItems =
                  getRemovedItems(
                    previousCart,
                    nextCart
                  );


                updateCartState(
                  nextCart
                );


                if (
                  !removedItems.length
                ) {
                  return;
                }


                /*
                  Guardamos lo eliminado para
                  poder deshacerlo si pulsa CTA.
                */
                pendingRemovedItems =
                  removedItems;


                var allowEmpty =
                  showAfterEmptyingCart &&
                  nextCart.item_count ===
                    0;


                openPopup(
                  'product-removed',
                  allowEmpty
                );

              }
            )
            .catch(
              function () {}
            );

        },
        130
      );

  }


  /* ========================================
     INTERCEPTAR FETCH
  ======================================== */

  window.fetch =
    function () {

      var args =
        Array.prototype.slice.call(
          arguments
        );


      var input =
        args[0];


      var url =
        typeof input ===
        'string'
          ? input
          : (
              input &&
              input.url
                ? input.url
                : ''
            );


      var cartMutation =
        isCartMutationUrl(
          url
        );


      return originalFetch
        .apply(
          window,
          args
        )
        .then(
          function (response) {

            if (
              cartMutation
            ) {

              window.setTimeout(
                scheduleCartSync,
                20
              );

            }


            return response;

          }
        );

    };


  /* ========================================
     INTERCEPTAR XMLHttpRequest
  ======================================== */

  var originalXHROpen =
    XMLHttpRequest.prototype
      .open;


  var originalXHRSend =
    XMLHttpRequest.prototype
      .send;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url
    ) {

      this.__luxCartMutation =
        isCartMutationUrl(
          url
        );


      return originalXHROpen
        .apply(
          this,
          arguments
        );

    };


  XMLHttpRequest.prototype.send =
    function () {

      var xhr =
        this;


      if (
        xhr.__luxCartMutation
      ) {

        xhr.addEventListener(
          'load',
          function () {

            window.setTimeout(
              scheduleCartSync,
              20
            );

          },
          {
            once: true
          }
        );

      }


      return originalXHRSend
        .apply(
          this,
          arguments
        );

    };


  /* ========================================
     INICIAR
  ======================================== */

  initializeCart();

  checkDiscountFeedback();

})();